<!--Footer-->
<footer
  class="bg-black text-center text-white dark:bg-black dark:text-neutral-200 lg:text-left"
>
  <!-- Social icons -->
  <div class="border-b-2 border-neutral-200 p-6 dark:border-neutral-500">
    <div class="container mx-auto px-10">
      <div class="flex items-center justify-center lg:justify-between">
        <div class="me-12 hidden lg:block">
          <span>Get connected with us on social networks :</span>
        </div>
        <div class="flex justify-center">
          <a
            href="https://www.facebook.com/profile.php?id=100083363979626" aria-label="Visit our Facebook page"
            class="me-6 text-white dark:text-gray-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"
              />
            </svg>
          </a>

          <a
            href="https://www.instagram.com/vin_marts?igsh=MWVzcXB0MWlzOGZmZg%3D%3D&utm_source=qr" aria-label="Visit our Instagram profile"
            class="me-6 text-white dark:text-gray-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- Social icons -->

  <!-- Main footer content -->
  <div class="container mx-auto px-4">
    <div class="mx-6 py-10 text-center md:text-left">
      <div class="grid-1 grid gap-8 md:grid-cols-2 lg:grid-cols-4">
        <div class="">
          <h2 class="mb-4 flex items-center justify-center font-semibold uppercase md:justify-start"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="me-3 h-4 w-4"
            >
              <path
                d="M12.378 1.602a.75.75 0 00-.756 0L3 6.632l9 5.25 9-5.25-8.622-5.03zM21.75 7.93l-9 5.25v9l8.628-5.032a.75.75 0 00.372-.648V7.93zM11.25 22.18v-9l-9-5.25v8.57a.75.75 0 00.372.648l8.628 5.033z"
              />
            </svg>
            Vinmarts
          </h2>
          <p class="justify">
            VinMarts connects buyers and sellers across India, offering a wide
            range of products with secure payments, trusted sellers, and fast
            delivery for a seamless online shopping experience.
          </p>
          <a
            class="p-3 my-4 flex items-start mx-auto rounded-xl outline outline-2  bg-indigo-700 text-white "
            href="https://play.google.com/store/apps/details?id=com.vinmarts.VinMarts&hl=en_IN"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="w-10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-10 h-10"
                viewBox="0 0 512 512"
              >
                <path
                  fill="#e8e2e9"
                  d="M48 59.49v393a4.33 4.33 0 0 0 7.37 3.07L260 256L55.37 56.42A4.33 4.33 0 0 0 48 59.49M345.8 174L89.22 32.64l-.16-.09c-4.42-2.4-8.62 3.58-5 7.06l201.13 192.32ZM84.08 472.39c-3.64 3.48.56 9.46 5 7.06l.16-.09L345.8 338l-60.61-57.95ZM449.38 231l-71.65-39.46L310.36 256l67.37 64.43L449.38 281c19.49-10.77 19.49-39.23 0-50"
                />
              </svg>
            </div>
            <div>
              <div class="text-sm font-extrabold text-white">Download on the</div>
              <div class="text-2xl">Google Play</div>
            </div>
          </a>
        </div>
        <div class="">
          <h2
            class="mb-4 flex justify-center font-semibold uppercase md:justify-start"
          >
            Important Link
          </h2>
          <p class="mb-4 flex justify-center md:justify-start">
            <a
              href="https://seller.vinmarts.in"
              target="_blank"
              class="flex text-white dark:text-neutral-200"
            >
              <svg
                viewBox="0 0 512 512"
                class="me-3 h-7 w-7"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                fill="#000000"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <title>sell on Vinmarts</title>
                  <g
                    id="Page-1"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g
                      id="add"
                      fill="white"
                      transform="translate(62.226343, 62.126933)"
                    >
                      <path
                        d="M1.42108547e-14,1.42108547e-14 L383.886753,103.687042 L297.711686,189.91687 L379.692392,271.892421 L271.812236,379.775061 L189.860861,297.799511 L103.685794,384 L1.42108547e-14,1.42108547e-14 Z M60.5256571,60.5397333 L125.63499,301.6704 L189.860861,237.450832 L271.789657,319.419733 L319.341657,271.889067 L237.380541,189.927401 L301.592324,125.649067 L60.5256571,60.5397333 Z"
                        id="Fill-6"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
              Sell on Vinmarts</a
            >
          </p>
          <p
            class="flex items-center justify-center md:justify-start cursor-pointer"
            routerLink="/termsCondition"
            (click)="scrollToTop()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="me-3 h-7 w-7"
              viewBox="0 0 24 24"
            >
              <g
                fill="none"
                stroke="#e8e2e9"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                color="#e8e2e9"
              >
                <path
                  d="M11.47 22c-3.992 0-5.989 0-7.23-1.172C3 19.657 3 17.771 3 14v-4c0-3.771 0-5.657 1.24-6.828C5.481 2 7.478 2 11.47 2h1.06c3.993 0 5.989 0 7.23 1.172C21 4.343 21 6.229 21 10m-9.5 12H13M8 7h8m-8 5h5"
                />
                <path
                  d="m17.5 18.59l-.902 3.153a.2.2 0 0 0 .268.235l1.985-.793a.4.4 0 0 1 .298 0l2.004.8a.2.2 0 0 0 .27-.226l-.764-3.268M22 15.995A3 3 0 0 0 19 13c-1.657 0-3 1.341-3 2.995a2.997 2.997 0 0 0 3 2.995c1.657 0 3-1.34 3-2.995"
                />
              </g>
            </svg>

            terms & condition
          </p>
          <p
            class="flex items-center justify-center md:justify-start mt-2 cursor-pointer"
            routerLink="/policyPrivacy"
            (click)="scrollToTop()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="me-3 h-7 w-7"
              viewBox="0 0 24 24"
            >
              <path
                fill="white"
                d="M11 17h2v-6h-2zm1-8q.425 0 .713-.288T13 8t-.288-.712T12 7t-.712.288T11 8t.288.713T12 9m0 13q-3.475-.875-5.738-3.988T4 11.1V5l8-3l8 3v6.1q0 3.8-2.262 6.913T12 22m0-2.1q2.6-.825 4.3-3.3t1.7-5.5V6.375l-6-2.25l-6 2.25V11.1q0 3.025 1.7 5.5t4.3 3.3m0-7.9"
              />
            </svg>

            Policy and Privacy
          </p>
        </div>
        <div class="">
          <h2
            class="mb-4 flex justify-center font-semibold uppercase md:justify-start"
          >
            Let Us Help You
          </h2>
          <p class="mb-4">
            <span
              (click)="yourAccount()"
              class="text-white dark:text-neutral-200 cursor-pointer"
              >Your Account</span
            >
          </p>
          <!-- <p class="mb-4"></p> -->
          <p class="text-white mb-4 dark:text-neutral-200 cursor-pointer">
            100% Purchase Protection
          </p>
          <p>
            <span
              (click)="helpCenter()"
              class="text-white dark:text-neutral-200 cursor-pointer"
              >Help</span
            >
          </p>
          <p class="mt-4">
            <span
            routerLink="/faq"
              class="text-white dark:text-neutral-200 cursor-pointer mt-4"
              >FAQ</span
            >
          </p>
        </div>
        <div>
          <h2
            class="mb-4 flex justify-center font-semibold uppercase md:justify-start"
          >
            Contact
          </h2>
          <p class="mb-4 flex items-center justify-center md:justify-start">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="me-3 h-5 w-5"
            >
              <path
                d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z"
              />
              <path
                d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z"
              />
            </svg>
            Khajuri sadak Bhopal M.p(India)
          </p>
          <p class="mb-4 flex items-center justify-center md:justify-start">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="me-3 h-5 w-5"
            >
              <path
                d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z"
              />
              <path
                d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z"
              />
            </svg>
            <a href="mailto:contact@vinmarts.in">contact&#64;vinmarts.in</a>
          </p>
          <p class="mb-4 flex items-center justify-center md:justify-start">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="me-3 h-5 w-5"
            >
              <path
                fill-rule="evenodd"
                d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
                clip-rule="evenodd"
              />
            </svg>
            <a href="tel:+7987293301">(+91)7987293301</a>
          </p>

          <p class="mb-4 flex items-center justify-center md:justify-start">
            <svg
              class="me-3 h-6 w-6"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.50002 12C3.50002 7.30558 7.3056 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C10.3278 20.5 8.77127 20.0182 7.45798 19.1861C7.21357 19.0313 6.91408 18.9899 6.63684 19.0726L3.75769 19.9319L4.84173 17.3953C4.96986 17.0955 4.94379 16.7521 4.77187 16.4751C3.9657 15.176 3.50002 13.6439 3.50002 12ZM12 1.5C6.20103 1.5 1.50002 6.20101 1.50002 12C1.50002 13.8381 1.97316 15.5683 2.80465 17.0727L1.08047 21.107C0.928048 21.4637 0.99561 21.8763 1.25382 22.1657C1.51203 22.4552 1.91432 22.5692 2.28599 22.4582L6.78541 21.1155C8.32245 21.9965 10.1037 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM14.2925 14.1824L12.9783 15.1081C12.3628 14.7575 11.6823 14.2681 10.9997 13.5855C10.2901 12.8759 9.76402 12.1433 9.37612 11.4713L10.2113 10.7624C10.5697 10.4582 10.6678 9.94533 10.447 9.53028L9.38284 7.53028C9.23954 7.26097 8.98116 7.0718 8.68115 7.01654C8.38113 6.96129 8.07231 7.046 7.84247 7.24659L7.52696 7.52195C6.76823 8.18414 6.3195 9.2723 6.69141 10.3741C7.07698 11.5163 7.89983 13.314 9.58552 14.9997C11.3991 16.8133 13.2413 17.5275 14.3186 17.8049C15.1866 18.0283 16.008 17.7288 16.5868 17.2572L17.1783 16.7752C17.4313 16.5691 17.5678 16.2524 17.544 15.9269C17.5201 15.6014 17.3389 15.308 17.0585 15.1409L15.3802 14.1409C15.0412 13.939 14.6152 13.9552 14.2925 14.1824Z"
                  fill="white"
                ></path>
              </g>
            </svg>
            <a
              href="https://wa.me/7987293301?text=Hello%20there%2C%20I%20need%20more%20information"
              target="_blank"
              >Chat on WhatsApp</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
  <!-- Main footer content -->

  <!-- Copyrights -->
 <div class="bg-[#9A32CD] p-3 text-center text-white">
    <span>© 2023 Copyright </span>
    <span class="font-semibold text-white" routerLink="/">
      Vinmarts</span
    >
  </div>
  <!-- Copyrights -->
</footer>
<!--Footer-->
<!-- <div *ngFor="let user of users">
  <h1>{{user.name}} : {{user.age}} : {{user.email}}</h1>
</div> -->
